export const getUserLanguage = () => {
  try {
    return navigator.languages[0].split('-')[0];
  } catch {
    return 'en';
  }
};
